var map = {
	"./bad-panda-logo.svg": "./src/svg/bad-panda-logo.svg",
	"./icon/add-circle.svg": "./src/svg/icon/add-circle.svg",
	"./icon/add-package.svg": "./src/svg/icon/add-package.svg",
	"./icon/add-user.svg": "./src/svg/icon/add-user.svg",
	"./icon/alert.svg": "./src/svg/icon/alert.svg",
	"./icon/antenna.svg": "./src/svg/icon/antenna.svg",
	"./icon/batch.svg": "./src/svg/icon/batch.svg",
	"./icon/battery-full.svg": "./src/svg/icon/battery-full.svg",
	"./icon/cancel-circle.svg": "./src/svg/icon/cancel-circle.svg",
	"./icon/cancel.svg": "./src/svg/icon/cancel.svg",
	"./icon/chat.svg": "./src/svg/icon/chat.svg",
	"./icon/check-circle.svg": "./src/svg/icon/check-circle.svg",
	"./icon/checked.svg": "./src/svg/icon/checked.svg",
	"./icon/chevron-down-circle.svg": "./src/svg/icon/chevron-down-circle.svg",
	"./icon/chevron-down.svg": "./src/svg/icon/chevron-down.svg",
	"./icon/chevron-left.svg": "./src/svg/icon/chevron-left.svg",
	"./icon/chevron-right.svg": "./src/svg/icon/chevron-right.svg",
	"./icon/chevron-up.svg": "./src/svg/icon/chevron-up.svg",
	"./icon/circle-tick.svg": "./src/svg/icon/circle-tick.svg",
	"./icon/clock.svg": "./src/svg/icon/clock.svg",
	"./icon/cloud.svg": "./src/svg/icon/cloud.svg",
	"./icon/config.svg": "./src/svg/icon/config.svg",
	"./icon/console.svg": "./src/svg/icon/console.svg",
	"./icon/console2.svg": "./src/svg/icon/console2.svg",
	"./icon/controls.svg": "./src/svg/icon/controls.svg",
	"./icon/customer.svg": "./src/svg/icon/customer.svg",
	"./icon/download.svg": "./src/svg/icon/download.svg",
	"./icon/edit.svg": "./src/svg/icon/edit.svg",
	"./icon/empty-space.svg": "./src/svg/icon/empty-space.svg",
	"./icon/event.svg": "./src/svg/icon/event.svg",
	"./icon/fox.svg": "./src/svg/icon/fox.svg",
	"./icon/freezer.svg": "./src/svg/icon/freezer.svg",
	"./icon/help.svg": "./src/svg/icon/help.svg",
	"./icon/hide-password.svg": "./src/svg/icon/hide-password.svg",
	"./icon/layer.svg": "./src/svg/icon/layer.svg",
	"./icon/legal.svg": "./src/svg/icon/legal.svg",
	"./icon/link.svg": "./src/svg/icon/link.svg",
	"./icon/link2.svg": "./src/svg/icon/link2.svg",
	"./icon/location.svg": "./src/svg/icon/location.svg",
	"./icon/login.svg": "./src/svg/icon/login.svg",
	"./icon/logout.svg": "./src/svg/icon/logout.svg",
	"./icon/map-player.svg": "./src/svg/icon/map-player.svg",
	"./icon/map-zombie.svg": "./src/svg/icon/map-zombie.svg",
	"./icon/map-zombie2.svg": "./src/svg/icon/map-zombie2.svg",
	"./icon/map.svg": "./src/svg/icon/map.svg",
	"./icon/more.svg": "./src/svg/icon/more.svg",
	"./icon/ninja.svg": "./src/svg/icon/ninja.svg",
	"./icon/note.svg": "./src/svg/icon/note.svg",
	"./icon/notification.svg": "./src/svg/icon/notification.svg",
	"./icon/package.svg": "./src/svg/icon/package.svg",
	"./icon/paid-receipt.svg": "./src/svg/icon/paid-receipt.svg",
	"./icon/paid.svg": "./src/svg/icon/paid.svg",
	"./icon/panda-face.svg": "./src/svg/icon/panda-face.svg",
	"./icon/panda-standing.svg": "./src/svg/icon/panda-standing.svg",
	"./icon/paw.svg": "./src/svg/icon/paw.svg",
	"./icon/pet-food.svg": "./src/svg/icon/pet-food.svg",
	"./icon/players.svg": "./src/svg/icon/players.svg",
	"./icon/product.svg": "./src/svg/icon/product.svg",
	"./icon/profile.svg": "./src/svg/icon/profile.svg",
	"./icon/refresh.svg": "./src/svg/icon/refresh.svg",
	"./icon/reset-password.svg": "./src/svg/icon/reset-password.svg",
	"./icon/save.svg": "./src/svg/icon/save.svg",
	"./icon/screwdriver.svg": "./src/svg/icon/screwdriver.svg",
	"./icon/search.svg": "./src/svg/icon/search.svg",
	"./icon/servers-add.svg": "./src/svg/icon/servers-add.svg",
	"./icon/servers-secure.svg": "./src/svg/icon/servers-secure.svg",
	"./icon/settings.svg": "./src/svg/icon/settings.svg",
	"./icon/shipment.svg": "./src/svg/icon/shipment.svg",
	"./icon/show-password.svg": "./src/svg/icon/show-password.svg",
	"./icon/sliders.svg": "./src/svg/icon/sliders.svg",
	"./icon/some-checked.svg": "./src/svg/icon/some-checked.svg",
	"./icon/star.svg": "./src/svg/icon/star.svg",
	"./icon/stopwatch.svg": "./src/svg/icon/stopwatch.svg",
	"./icon/supplier.svg": "./src/svg/icon/supplier.svg",
	"./icon/tag.svg": "./src/svg/icon/tag.svg",
	"./icon/target.svg": "./src/svg/icon/target.svg",
	"./icon/unchecked.svg": "./src/svg/icon/unchecked.svg",
	"./icon/vip.svg": "./src/svg/icon/vip.svg",
	"./icon/wrench.svg": "./src/svg/icon/wrench.svg",
	"./icon/zombie.svg": "./src/svg/icon/zombie.svg",
	"./puppy.svg": "./src/svg/puppy.svg",
	"./zbad-panda-logo.svg": "./src/svg/zbad-panda-logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/svg sync recursive ^\\.\\/.*\\.svg$";